import { ICreateMessageResponse } from '../../../repositories/demand/v5/create-message';
import { ICreatePersonalMessageResponse } from '../../../repositories/demand/v2/create-personal-message';

export const isMessageSubmitFormResponse = (
  response: ICreateMessageResponse | ICreatePersonalMessageResponse,
): response is ICreateMessageResponse => {
  return 'sentMessageFromCian' in response;
};
